import React, { useEffect, useRef, useState } from "react";
import { Checkbox, CircularProgress, FormControlLabel, TextField, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import ActionDialog from "../../ActionDialog";
import { editAgreementJobTitle } from "../../../../actions";
import { useManagementAction } from "../../../../hooks/useManagementAction";

const ChangeJobTitle = ({ open, handleCloseDialog, user, fetchUser }) => {
  const { handleManagementAction } = useManagementAction();

  const [loading, setLoading] = useState(false);
  const defaultJobTitle = user.contractAgent.contractAgentClass.jobTitle;
  const initialJobTitle = user.contractAgent.jobTitle || "";
  const [jobTitle, setJobTitle] = useState(initialJobTitle);
  const [useDefault, setUseDefault] = useState(user.contractAgent.defaultJobTitle);

  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const onFinish = () => {
    if (!isMountedRef.current) return;

    setLoading(false);
    handleCloseDialog();
  }

  const handleSubmit = async () => {
    if (jobTitle === "") {
      return;
    }
    setLoading(true);
    await handleManagementAction({
      body: { editedUserId: user.id, jobTitle },
      managementAction: editAgreementJobTitle,
      onComplete: fetchUser,
      onFinish,
      successMessage: "app.edit.sucesfully",
    });
  };

  const handleClose = () => {
    setJobTitle(initialJobTitle);
    setUseDefault(!initialJobTitle);
    handleCloseDialog();
  };

  useEffect(() => {
    setJobTitle(useDefault ? null : initialJobTitle);
  }, [useDefault, defaultJobTitle, initialJobTitle]);

  return (
    <ActionDialog
      title="app.edit"
      open={open}
      onAccept={handleSubmit}
      onClose={handleClose}
      textConfirm="app.edit"
      maxWidth="xs"
      enableConfirmButton={!loading}
      disableConfirmButton={jobTitle === ""}
      textToConfirmation={"app.confirm.changeJobTitle"}
    >
      <TextField
        id="job-title"
        fullWidth
        label={<FormattedMessage id="app.manager.jobTitle" />}
        value={jobTitle ?? defaultJobTitle}
        onChange={(e) => setJobTitle(e.target.value)}
        InputLabelProps={{ shrink: true, disabled: useDefault || loading }}
        InputProps={{ disabled: useDefault || loading }}
        variant="outlined"
        size="small"
        error={jobTitle === ""}
        helperText={
          jobTitle === "" && (
            <Typography
              component={"span"}
              color="error"
            >
              <FormattedMessage id="app.manager.jobTitle.isEmpty" />
            </Typography>
          )
        }
      />
      <FormControlLabel
        disabled={loading}
        control={
          <Checkbox
            checked={useDefault}
            onChange={() => setUseDefault((prev) => !prev)}
            color="primary"
          />
        }
        label={<FormattedMessage id="app.manager.useDefault" />}
      />
      {loading && (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      )}
    </ActionDialog>
  );
};

export default ChangeJobTitle;
